import { DateAdapter } from './../../shared/adapters/date-adapter';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { Pagination } from '../../shared/models/pagination.model';
import { QrCode } from '../../shared/models/qr-code.model';
import { withDateAdapter, withDateAdapterPage } from '../../shared/rxjs/with-date-adapter';


@Injectable({
  providedIn: 'root'
})
export class QrCodeService {
  private readonly endpoint = `${env.baseAPIUrl}/qrcode`;

  private readonly dateFields = ['createdAt', 'updatedAt', 'deletedAt'];
  private readonly transformDate = withDateAdapter<QrCode>(this.dateFields);
  private readonly transformDatePage = withDateAdapterPage<Pagination<QrCode>>(this.dateFields);

  constructor(private readonly http: HttpClient) { }

  getQrCodeById(qrCodeId: string): Observable<QrCode> {
    return this.http.get<QrCode>(`${this.endpoint}/${qrCodeId}`)
      .pipe(this.transformDate);
  }

  createQrCodeBatch(quantity: number): Observable<QrCode[]> {
    return this.http.post<QrCode[]>(`${this.endpoint}`, { quantity })
      .pipe(
        map(arr => arr.map(item => DateAdapter.fromAPI(item, this.dateFields)))
      );
  }

  paginateQrCode(page: number, pageSize: number = 10, filter: string = 'all'): Observable<Pagination<QrCode>> {
    return this.http.get<Pagination<QrCode>>(`${this.endpoint}?page=${page}&pageSize=${pageSize}&filter=${filter}`)
      .pipe(this.transformDatePage);
  }

  paginateQrCodeByUser(userId: string, page: number = 0, pageSize: number = 10): Observable<Pagination<QrCode>> {
    return this.http.get<Pagination<QrCode>>(`${this.endpoint}/user/${userId}?page=${page}&pageSize=${pageSize}`)
      .pipe(this.transformDatePage);
  }

  bindPetToQrCode(codeAndPet: { qrcodeId: string, petId: string }): Observable<QrCode> {
    return this.http.post<QrCode>(`${this.endpoint}/link`, codeAndPet)
      .pipe(this.transformDate);

  }

  deleteQrCode(qrCodeId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${qrCodeId}`);
  }
}
